import { actions } from './hospitalization_conclusions/actions'
import { getters } from './hospitalization_conclusions/getters'
import { state } from './hospitalization_conclusions/state'
import { mutations } from './hospitalization_conclusions/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
